import React from 'react';

import { BlogPostPreview } from '@commons/blog-post-preview/BlogPostPreview';

import { relatedPostsContainer, blogpostsContainer } from './related-posts.module.scss';

export default function RelatedPosts({ posts }) {
  return (
    <div className={relatedPostsContainer}>
      <h3>Read also</h3>
      <div className={blogpostsContainer}>
        {posts.slice(0, 2).map((value, index) => value && <BlogPostPreview key={index} {...value} />)}
      </div>
    </div>
  );
}
